export function unitMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      unitId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateUnitId(json) {
  return {
    data: {...json, id: json.objectId},
  };
}
export function fixGetManyUnits(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      categoryId: resource.objectId,
    })),
  };
}

export function fixCreateUnitId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function unitMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, unitId: json.result.objectId},
  };
}